import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { deleteAllAlerts } from "../../api";

export default function ClearAlertsModal({ servers }) {
  const { toast, closeModal } = useUI();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const list = Object.values(servers || {});

  const submit = async () => {
    if (!code) return toast("Vui lòng chọn máy chủ", "err");
    setBusy(true);
    try {
      const { ok, data } = await deleteAllAlerts(code);
      if (ok) {
        toast(
          data.deleted != null
            ? `Đã xoá ${data.deleted} dòng log của ${code}`
            : data.message || "Đã xoá log",
          "ok"
        );
        closeModal();
      } else {
        toast(data.message || "Lỗi server", "err");
      }
    } catch {
      toast("Không kết nối được BackendNode", "err");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <div className="field-lbl">Chọn máy chủ *</div>
      <select
        style={selectStyle}
        value={code}
        onChange={(e) => setCode(e.target.value)}
      >
        <option value="">— Chọn máy chủ —</option>
        {list.map((sv) => (
          <option key={sv.ServerCode} value={sv.ServerCode}>
            {sv.ServerCode} {sv.ServerName ? ` · ${sv.ServerName}` : ""}
          </option>
        ))}
      </select>

      {code && (
        <div style={{
          background: "var(--red-soft)",
          border: "1px solid var(--red)",
          borderRadius: "10px",
          padding: "12px 14px",
          color: "var(--red)",
          fontSize: "13px",
          lineHeight: "1.5",
          marginTop: "12px",
        }}>
          Bạn chắc chắn muốn xoá <strong>toàn bộ log</strong> của <strong>{code}</strong> (gồm cả lịch sử metrics, trạng thái ứng dụng và cảnh báo)? Hành động này không thể hoàn tác.
        </div>
      )}

      <div className="modal-footer" style={{ marginTop: "20px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal} disabled={busy}>
          Huỷ
        </button>
        <button
          className="mbtn mbtn-danger"
          onClick={submit}
          disabled={busy || !code}
        >
          {busy ? "Đang xoá…" : "✕ Xoá tất cả"}
        </button>
      </div>
    </div>
  );
}

const selectStyle = {
  width: "100%",
  height: "42px",
  padding: "0 13px",
  borderRadius: "10px",
  background: "var(--surface2)",
  border: "1px solid var(--border)",
  color: "var(--text)",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
  cursor: "pointer",
};
